import styled from 'styled-components'

import { CommandInputGroup } from '../../../styles/utilities'

export const OcppPanelContainer = styled.div`
    button {
        min-width: 150px;
    }

    h4 {
        margin-bottom: ${({ theme }) => theme.sizing.margin.l};
    }
`

export const ConnectorHeader = styled.div`
    font-size: 16px;
    margin-bottom: ${({ theme }) => theme.sizing.margin.l};
`

export const SIcon = styled.span`
    font-weight: var(--font-weight-extra-bold);
    font-size: 16px;
    color: #337ab7;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
        color: #23527c;
    }
`

export const SInput = styled.input`
    display: block;
    width: 100%;
    height: 39px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.5em;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &[type='number'] {
        -moz-appearance: textfield;
    }

    &:disabled {
        background-color: #eeeeee;
    }
`

export const SForm = styled.div`
    ${CommandInputGroup}
`

export const SActions = styled(SForm)`
    padding-top: 60px;
`
